// extracted by LIB_CSS_EXTRACT_LOADER
import "./toggle_module.css"
export default {"root":"root-_dVwoF","default":"default-NBVN1k","outline":"outline-PeBXQ5","sizeDefault":"sizeDefault-P9jvGo","sizeSm":"sizeSm-OUenVH","sizeLg":"sizeLg-kfUHX1"};